import React, { useEffect, useState } from "react";
import Select, { MultiValue, SingleValue, ActionMeta } from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option[];
  value?: Option[];
  className?: string;
  styles?: any;
  onValueChange?: (value: string) => void;
  onChange?: (option: Option[] | null) => void;
  required?: boolean;
  placeholder?: string;
  isMulti?: boolean;
}

const MultiSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  value,
  className,
  onValueChange,
  onChange,
  required,
  placeholder = "Select",
  isMulti = false,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option[]>(
    value || defaultValue || []
  );

  // const customStyles = {
  //   option: (base: any, state: any) => ({
  //     ...base,
  //     color: "#6A7287",
  //     backgroundColor: state.isSelected ? "#ddd" : "white",
  //     cursor: "pointer",
  //     "&:hover": {
  //       backgroundColor: state.isFocused ? "#3D5EE1" : "blue",
  //       color: state.isFocused ? "#fff" : "#6A7287",
  //     },
  //   }),
  // };

  const handleChange = (newValue: MultiValue<Option> | SingleValue<Option>, actionMeta: ActionMeta<Option>) => {
    const options = newValue ? (Array.isArray(newValue) ? newValue : [newValue]) : [];
    setSelectedOption(options);
    if (onValueChange) {
      onValueChange(options.map(option => option.value).join(", ") || "");
    }
    if (onChange) {
      onChange(isMulti ? options : options.length > 0 ? [options[0]] : null);
    }
  };
  useEffect(() => {
    setSelectedOption(value || defaultValue || []);
  }, [value, defaultValue]);

  return (
    <div className={`select-wrapper ${required ? "required" : ""}`}>
      <Select
        classNamePrefix="react-select"
        className={className}
        // styles={customStyles}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        isClearable={!required}
        isMulti={isMulti}
      />
      {required && selectedOption.length === 0 && (
        <div className="invalid-feedback d-none">This field is required</div>
      )}
    </div>
  );
};

export default MultiSelect;
